import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownModule, SelectButtonModule, SharedModule } from 'primeng';
import { SelectItem } from 'primeng/api';
import { VmeCommonModule } from '../../../vme-common.module';
import { OrderBookingHealthCheckTab } from '../../../enums/order-booking-health-check/order-booking-health-check.enums';

@Component({
  selector: 'order-booking-tabs',
  standalone: true,
  imports: [CommonModule, DropdownModule, SelectButtonModule, SharedModule, VmeCommonModule],
  templateUrl: './order-booking-tabs.component.html',
  styleUrls: ['./order-booking-tabs.component.scss'],
})
export class OrderBookingTabsComponent {
  @Input() selectedTab: OrderBookingHealthCheckTab = OrderBookingHealthCheckTab.AllBookings;
  @Input() counts: Record<OrderBookingHealthCheckTab, number>;
  @Input() loading: boolean = false;

  @Output() tabChanged = new EventEmitter<OrderBookingHealthCheckTab>();

  public tabOptions: SelectItem[] = [
    { label: 'All Bookings', value: OrderBookingHealthCheckTab.AllBookings },
    { label: 'Assigned To You', value: OrderBookingHealthCheckTab.AssignedToYou },
    { label: 'Assigned To Others', value: OrderBookingHealthCheckTab.AssignedToOthers },
    { label: 'Unassigned', value: OrderBookingHealthCheckTab.Unassigned },
  ];

  protected readonly Object = Object;
}
